import { createApp } from "vue";

import App from "./App.vue";
import {
  pinia,
  createAppRouter,
  installProjectContext,
  ElementPlus,
} from "./providers";
import { i18n } from "@/shared/i18n";
import { loadConfig } from "@/shared/config/runtime";
import { updateApiBaseUrl } from "@/shared/api";

export async function initApp(): Promise<void> {
  // Загружаем runtime конфигурацию перед инициализацией приложения
  try {
    await loadConfig();
    updateApiBaseUrl();
  } catch (error) {
    console.error("Failed to load runtime config:", error);
    // Продолжаем с дефолтными настройками
  }

  // Создаём router ПОСЛЕ загрузки конфига, чтобы использовать правильный basePath
  const router = createAppRouter();

  const app = createApp(App);

  app.use(pinia);
  app.use(router);
  app.use(i18n);
  app.use(ElementPlus);

  // Адрес и рабочий контекст связываются до монтирования оболочки: проект из
  // ссылки становится выбранным раньше, чем оболочка загрузит зависимое от
  // него, поэтому содержимого не того проекта не показывается ни на мгновение
  // (app-shell-shell-routing-R12).
  installProjectContext(router);

  app.mount("#app");
}
